var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteOpening = function SvgQuoteOpening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.972 9.089a.25.25 0 0 1 .25.25v8.411a.25.25 0 0 1-.25.25H.25a.25.25 0 0 1-.25-.25V8.135C0 3.741 3.522.137 7.885.004a.245.245 0 0 1 .25.246v4c0 .138-.112.25-.25.258A3.638 3.638 0 0 0 4.5 8.135v.704c0 .138.112.25.25.25h4.222Z",
    fill: "currentColor"
  })));
};
export default SvgQuoteOpening;